export function Arrow() {
    return (
        <svg width="14" height="9" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M6.00013 5.79969C5.5918 5.79969 5.18347 5.64219 4.8743 5.33303L1.07097 1.52969C0.9018 1.36053 0.9018 1.08053 1.07097 0.91136C1.24013 0.742193 1.52013 0.742193 1.6893 0.91136L5.49263 4.71469C5.77263 4.99469 6.22763 4.99469 6.50763 4.71469L10.311 0.91136C10.4801 0.742193 10.7601 0.742193 10.9293 0.91136C11.0985 1.08053 11.0985 1.36053 10.9293 1.52969L7.12597 5.33303C6.8168 5.64219 6.40847 5.79969 6.00013 5.79969Z"
                fill="#666C89"
                stroke="#666C89"
                stroke-width="0.5"
            />
        </svg>
    );
}
